export interface AccountProps {
  code:
    | 'ROLE_MARK'
    | 'ROLE_GOWID'
    | 'ROLE_COMPANY'
    | 'ROLE_PARTNER'
    | undefined;
  desc: string;
}

export const ACCOUNT_ROLE: AccountProps[] = [
  { code: 'ROLE_MARK', desc: '마크앤컴퍼니' },
  { code: 'ROLE_GOWID', desc: '고위드' },
  { code: 'ROLE_COMPANY', desc: '관리자 계정' },
  { code: 'ROLE_PARTNER', desc: '참여자 계정' },
];
